(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const ZOOM = 2.6;
  const LENS = 0.34;

  const hiResUrl = (image) => {
    const fromSrcset = (image.getAttribute('srcset') || '')
      .split(',')
      .map((part) => {
        const [url, width] = part.trim().split(/\s+/);
        return { url, width: parseInt(width, 10) || 0 };
      })
      .filter((item) => item.url)
      .sort((a, b) => b.width - a.width);
    return fromSrcset[0]?.url || image.currentSrc || image.src;
  };

  const bindLensZoom = (image) => {
    if (image.dataset.magnifyBound === 'true') return;
    image.dataset.magnifyBound = 'true';

    const opener = image.closest('.product__modal-opener');
    const frame = image.closest('.product-media-container') || opener || image.parentElement;
    const gallery = image.closest('media-gallery');
    if (!frame || !gallery) return;

    gallery.classList.add('meroo-zoom-host');
    let lens = null;
    let pane = null;

    const ensure = () => {
      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'meroo-zoom-lens';
        lens.setAttribute('aria-hidden', 'true');
        frame.appendChild(lens);
      }
      if (!pane) {
        pane = document.createElement('div');
        pane.className = 'meroo-zoom-pane';
        pane.setAttribute('aria-hidden', 'true');
        document.body.appendChild(pane);
      }
      pane.style.backgroundImage = `url("${hiResUrl(image)}")`;
    };

    const hide = () => {
      lens?.classList.remove('is-visible');
      if (pane) {
        pane.classList.remove('is-visible');
        pane.style.backgroundImage = '';
      }
    };

    const move = (event) => {
      if (!canHover.matches) return;
      // Only zoom the active slide image
      const slide = image.closest('.product__media-item');
      if (slide && !slide.classList.contains('is-active') && gallery.querySelector('.product__media-item.is-active')) {
        hide();
        return;
      }

      ensure();
      const rect = frame.getBoundingClientRect();
      if (rect.width < 40 || rect.height < 40) return;

      const lensSize = Math.max(80, Math.min(rect.width, rect.height) * LENS);
      let x = event.clientX - rect.left - lensSize / 2;
      let y = event.clientY - rect.top - lensSize / 2;
      x = Math.max(0, Math.min(x, rect.width - lensSize));
      y = Math.max(0, Math.min(y, rect.height - lensSize));

      lens.style.width = `${lensSize}px`;
      lens.style.height = `${lensSize}px`;
      lens.style.transform = `translate(${x}px, ${y}px)`;
      lens.classList.add('is-visible');

      const paneSize = Math.min(Math.max(rect.height, 320), Math.min(520, window.innerHeight - 32));
      const galleryRect = gallery.getBoundingClientRect();
      let left = galleryRect.right + 16;
      let top = Math.max(16, galleryRect.top);

      if (left + paneSize > window.innerWidth - 16) {
        left = Math.max(16, galleryRect.left - paneSize - 16);
      }
      if (top + paneSize > window.innerHeight - 16) {
        top = Math.max(16, window.innerHeight - paneSize - 16);
      }

      pane.style.width = `${paneSize}px`;
      pane.style.height = `${paneSize}px`;
      pane.style.left = `${left}px`;
      pane.style.top = `${top}px`;

      const bgWidth = rect.width * ZOOM;
      const bgHeight = rect.height * ZOOM;
      const maxX = Math.max(0, bgWidth - paneSize);
      const maxY = Math.max(0, bgHeight - paneSize);
      const bgX = maxX === 0 ? 0 : (x / Math.max(rect.width - lensSize, 1)) * maxX;
      const bgY = maxY === 0 ? 0 : (y / Math.max(rect.height - lensSize, 1)) * maxY;

      pane.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
      pane.style.backgroundPosition = `-${bgX}px -${bgY}px`;
      pane.classList.add('is-visible');
    };

    const target = opener || frame;
    target.addEventListener('mousemove', move);
    target.addEventListener('mouseenter', move);
    target.addEventListener('mouseleave', hide);
  };

  const init = () => {
    document.querySelectorAll('.meroo-pdp .image-magnify-hover').forEach(bindLensZoom);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
